import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Research() {

    const { t } = useTranslation();
    const iframeSource = t('link.external.research');

    // Validate that the URL uses an allowed protocol to prevent javascript: URI injection
    const isValidUrl = (url) => {
        try {
            const parsed = new URL(url);
            return parsed.protocol === 'https:';
        } catch {
            return false;
        }
    };

    return (
        <div className="main-container">
            {isValidUrl(iframeSource) && (
                <iframe
                    width="100%"
                    height="700px"
                    scrolling="yes"
                    src={iframeSource}
                    title="Research"
                />
            )}
        </div>
    );
}